import { Country } from "./country";

interface Province {
  code: string;
  label: string;
}

export class Provinces {
  static readonly ITALY = new Provinces(Country.ITALY, [
    { code: "AG", label: "Agrigento" },
    { code: "AL", label: "Alessandria" },
    { code: "AN", label: "Ancona" },
    { code: "AO", label: "Aosta" },
    { code: "AQ", label: "L'Aquila" },
    { code: "AR", label: "Arezzo" },
    { code: "AP", label: "Ascoli-Piceno" },
    { code: "AT", label: "Asti" },
    { code: "AV", label: "Avellino" },
    { code: "BA", label: "Bari" },
    { code: "BT", label: "Barletta-Andria-Trani" },
    { code: "BL", label: "Belluno" },
    { code: "BN", label: "Benevento" },
    { code: "BG", label: "Bergamo" },
    { code: "BI", label: "Biella" },
    { code: "BO", label: "Bologna" },
    { code: "BZ", label: "Bolzano" },
    { code: "BS", label: "Brescia" },
    { code: "BR", label: "Brindisi" },
    { code: "CA", label: "Cagliari" },
    { code: "CL", label: "Caltanissetta" },
    { code: "CB", label: "Campobasso" },
    { code: "CI", label: "Carbonia Iglesias" },
    { code: "CE", label: "Caserta" },
    { code: "CT", label: "Catania" },
    { code: "CZ", label: "Catanzaro" },
    { code: "CH", label: "Chieti" },
    { code: "CO", label: "Como" },
    { code: "CS", label: "Cosenza" },
    { code: "CR", label: "Cremona" },
    { code: "KR", label: "Crotone" },
    { code: "CN", label: "Cuneo" },
    { code: "EN", label: "Enna" },
    { code: "FM", label: "Fermo" },
    { code: "FE", label: "Ferrara" },
    { code: "FI", label: "Firenze" },
    { code: "FG", label: "Foggia" },
    { code: "FC", label: "Forli-Cesena" },
    { code: "FR", label: "Frosinone" },
    { code: "GE", label: "Genova" },
    { code: "GO", label: "Gorizia" },
    { code: "GR", label: "Grosseto" },
    { code: "IM", label: "Imperia" },
    { code: "IS", label: "Isernia" },
    { code: "SP", label: "La-Spezia" },
    { code: "LT", label: "Latina" },
    { code: "LE", label: "Lecce" },
    { code: "LC", label: "Lecco" },
    { code: "LI", label: "Livorno" },
    { code: "LO", label: "Lodi" },
    { code: "LU", label: "Lucca" },
    { code: "MC", label: "Macerata" },
    { code: "MN", label: "Mantova" },
    { code: "MS", label: "Massa-Carrara" },
    { code: "MT", label: "Matera" },
    { code: "VS", label: "Medio Campidano" },
    { code: "ME", label: "Messina" },
    { code: "MI", label: "Milano" },
    { code: "MO", label: "Modena" },
    { code: "MB", label: "Monza-Brianza" },
    { code: "NA", label: "Napoli" },
    { code: "NO", label: "Novara" },
    { code: "NU", label: "Nuoro" },
    { code: "OG", label: "Ogliastra" },
    { code: "OT", label: "Olbia Tempio" },
    { code: "OR", label: "Oristano" },
    { code: "PD", label: "Padova" },
    { code: "PA", label: "Palermo" },
    { code: "PR", label: "Parma" },
    { code: "PV", label: "Pavia" },
    { code: "PG", label: "Perugia" },
    { code: "PU", label: "Pesaro-Urbino" },
    { code: "PE", label: "Pescara" },
    { code: "PC", label: "Piacenza" },
    { code: "PI", label: "Pisa" },
    { code: "PT", label: "Pistoia" },
    { code: "PN", label: "Pordenone" },
    { code: "PZ", label: "Potenza" },
    { code: "PO", label: "Prato" },
    { code: "RG", label: "Ragusa" },
    { code: "RA", label: "Ravenna" },
    { code: "RC", label: "Reggio-Calabria" },
    { code: "RE", label: "Reggio-Emilia" },
    { code: "RI", label: "Rieti" },
    { code: "RN", label: "Rimini" },
    { code: "RM", label: "Roma" },
    { code: "RO", label: "Rovigo" },
    { code: "SA", label: "Salerno" },
    { code: "SS", label: "Sassari" },
    { code: "SV", label: "Savona" },
    { code: "SI", label: "Siena" },
    { code: "SR", label: "Siracusa" },
    { code: "SO", label: "Sondrio" },
    { code: "TA", label: "Taranto" },
    { code: "TE", label: "Teramo" },
    { code: "TR", label: "Terni" },
    { code: "TO", label: "Torino" },
    { code: "TP", label: "Trapani" },
    { code: "TN", label: "Trento" },
    { code: "TV", label: "Treviso" },
    { code: "TS", label: "Trieste" },
    { code: "UD", label: "Udine" },
    { code: "VA", label: "Varese" },
    { code: "VE", label: "Venezia" },
    { code: "VB", label: "Verbania" },
    { code: "VC", label: "Vercelli" },
    { code: "VR", label: "Verona" },
    { code: "VV", label: "Vibo-Valentia" },
    { code: "VI", label: "Vicenza" },
    { code: "VT", label: "Viterbo" },
  ]);

  static readonly USA = new Provinces(Country.USA, [
    { code: "AL", label: "Alabama" },
    { code: "AK", label: "Alaska" },
    { code: "AZ", label: "Arizona" },
    { code: "AR", label: "Arkansas" },
    { code: "CA", label: "California" },
    { code: "CO", label: "Colorado" },
    { code: "CT", label: "Connecticut" },
    { code: "DE", label: "Delaware" },
    { code: "PR", label: "Puerto Rico" },
    { code: "FL", label: "Florida" },
    { code: "GA", label: "Georgia" },
    { code: "HI", label: "Hawaii" },
    { code: "ID", label: "Idaho" },
    { code: "IL", label: "Illinois" },
    { code: "IN", label: "Indiana" },
    { code: "IA", label: "Iowa" },
    { code: "KS", label: "Kansas" },
    { code: "KY", label: "Kentucky" },
    { code: "LA", label: "Louisiana" },
    { code: "ME", label: "Maine" },
    { code: "MD", label: "Maryland" },
    { code: "MA", label: "Massachusetts" },
    { code: "MI", label: "Michigan" },
    { code: "MN", label: "Minnesota" },
    { code: "MS", label: "Mississippi" },
    { code: "MO", label: "Missouri" },
    { code: "MT", label: "Montana" },
    { code: "NE", label: "Nebraska" },
    { code: "NV", label: "Nevada" },
    { code: "NH", label: "New Hampshire" },
    { code: "NJ", label: "New Jersey" },
    { code: "NM", label: "New Mexico" },
    { code: "NY", label: "New York" },
    { code: "NC", label: "North Carolina" },
    { code: "ND", label: "North Dakota" },
    { code: "OH", label: "Ohio" },
    { code: "OK", label: "Oklahoma" },
    { code: "OR", label: "Oregon" },
    { code: "PA", label: "Pennsylvania" },
    { code: "RI", label: "Rhode Island" },
    { code: "SC", label: "South Carolina" },
    { code: "SD", label: "South Dakota" },
    { code: "TN", label: "Tennessee" },
    { code: "TX", label: "Texas" },
    { code: "UT", label: "Utah" },
    { code: "VT", label: "Vermont" },
    { code: "VA", label: "Virginia" },
    { code: "WA", label: "Washington" },
    { code: "WV", label: "West Virginia" },
    { code: "WI", label: "Wisconsin" },
    { code: "WY", label: "Wyoming" },
  ]);

  private constructor(
    public readonly country: Country,
    public readonly provinces: Array<Province>,
  ) {}

  static getProvincesByCountry(
    country: "italy" | "usa",
  ): Provinces | undefined {
    switch (country) {
      case "italy":
        return this.ITALY;
      case "usa":
        return this.USA;
      default:
        return undefined;
    }
  }

  static getSelectOptions(
    country: "italy" | "usa",
  ): { value: string; label: string }[] {
    const provinces = this.getProvincesByCountry(country);
    return (
      provinces?.provinces.map((province) => ({
        value: province.code,
        label: province.label,
      })) || []
    );
  }
}
